import {Pipe, PipeTransform} from '@angular/core';

export interface KeyValue<K, V> {
    key: K;
    value: V;
}

@Pipe({
    name: 'keys'
})
export class KeysPipe implements PipeTransform {
    transform(value): KeyValue<string, any>[] {
        return Object
            .keys(value)
            .filter(key => {
                return value[key] != null;
            })
            .map(key => {
                return {
                    key: key,
                    value: value[key]
                };
            });
    }
}
